import React from "react";
import { MetricComponentProps } from "../../types/metrics";
import MetricItem from "./MetricItem";
import { formatInterestRate } from "./metricHelpers";

export default function InterestRatePrimaryMetric({
  sim,
}: MetricComponentProps) {
  return (
    <MetricItem
      value={formatInterestRate(sim)}
      tooltip="Mortgage Interest Rate"
    />
  );
}
